export const EMPLOYEE_NOTIFICATIONS_QUERY_KEY = 'employee-notifications'
export const EMPLOYEE_NOTIFICATIONS_LATEST_QUERY_KEY =
  'employee-notifications-latest'
export const EMPLOYEE_NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY =
  'employee-notifications-unread-count'
